"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Help = function Help(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "HelpTitle HelpDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "HelpTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "HelpDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M30.444 16.243a14.147 14.147 0 0 0-2.96-8.671c.029-.102.044-.206.045-.312 0-.697-.565-1.262-1.262-1.262a1.147 1.147 0 0 0-.178 0c-5.498-5.33-14.236-5.33-19.733 0a1.282 1.282 0 0 0-.276-.03 1.249 1.249 0 0 0-1.2 1.728 14.182 14.182 0 0 0 .04 17.187 1.258 1.258 0 0 0 1.147 1.777c.137-.002.274-.026.404-.07 5.456 5.163 13.992 5.174 19.462.026a1.253 1.253 0 0 0 1.614-1.231 1.231 1.231 0 0 0-.08-.445 14.147 14.147 0 0 0 2.977-8.697zM7.227 6.732c5.016-4.768 12.879-4.799 17.933-.072-.103.184-.158.39-.16.6 0 .168.033.334.098.49l-4.334 4.337a6.133 6.133 0 0 0-9.182.125L7.204 7.829c.091-.176.14-.37.143-.569a1.262 1.262 0 0 0-.12-.528zm14.049 9.51a5.049 5.049 0 1 1-10.098 0 5.049 5.049 0 0 1 10.098 0zM6.08 24.14a1.511 1.511 0 0 0-.284.036 13.067 13.067 0 0 1-.103-15.698c.125.042.255.065.387.067.075 0 .149-.008.222-.022l4.622 4.626a6.12 6.12 0 0 0 .152 6.476l-4.592 4.591a1.209 1.209 0 0 0-.404-.076zm10.151 5.227a13.044 13.044 0 0 1-8.96-3.555c.048-.13.074-.267.076-.405a1.258 1.258 0 0 0-.076-.409l4.502-4.498a6.142 6.142 0 0 0 8.8.125l4.471 4.471a1.169 1.169 0 0 0 .058.8 13.044 13.044 0 0 1-8.87 3.449v.022zm10.427-5.182a1.204 1.204 0 0 0-.378-.067 1.271 1.271 0 0 0-.502.107l-4.476-4.48a6.133 6.133 0 0 0 .156-6.769l4.498-4.498c.105.029.214.044.324.045.163-.001.324-.033.476-.094a13.076 13.076 0 0 1-.098 15.756z",
    id: "refHelp-2eI_RMV1ZeM"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refHelp-2eI_RMV1ZeM"
  }));
};

Help.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Help.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Help;
exports["default"] = _default;